/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createCompany = /* GraphQL */ `mutation CreateCompany(
  $condition: ModelCompanyConditionInput
  $input: CreateCompanyInput!
) {
  createCompany(condition: $condition, input: $input) {
    address
    business_hours
    company_id
    contact_email
    contact_phone
    createdAt
    description
    logo
    name
    service_areas
    timestamps
    updatedAt
    website
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCompanyMutationVariables,
  APITypes.CreateCompanyMutation
>;
export const createCustomer = /* GraphQL */ `mutation CreateCustomer(
  $condition: ModelCustomerConditionInput
  $input: CreateCustomerInput!
) {
  createCustomer(condition: $condition, input: $input) {
    address
    billing_info
    createdAt
    notes
    pk
    preferences
    sk
    timestamps
    updatedAt
    user_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCustomerMutationVariables,
  APITypes.CreateCustomerMutation
>;
export const createItemInventory = /* GraphQL */ `mutation CreateItemInventory(
  $condition: ModelItemInventoryConditionInput
  $input: CreateItemInventoryInput!
) {
  createItemInventory(condition: $condition, input: $input) {
    company_id
    createdAt
    customer_price
    inventory_id
    item_id
    last_restocked
    location_in_warehouse
    quantity
    restock_threshold
    status
    supplier
    timestamps
    type
    unit_cost
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateItemInventoryMutationVariables,
  APITypes.CreateItemInventoryMutation
>;
export const createLandscapeObject = /* GraphQL */ `mutation CreateLandscapeObject(
  $condition: ModelLandscapeObjectConditionInput
  $input: CreateLandscapeObjectInput!
) {
  createLandscapeObject(condition: $condition, input: $input) {
    category
    color
    createdAt
    dimensions
    images
    installation_difficulty
    maintenance_level
    manufacturer
    material
    name
    object_id
    price_range
    timestamps
    updatedAt
    weather_resistance
    weight
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLandscapeObjectMutationVariables,
  APITypes.CreateLandscapeObjectMutation
>;
export const createPlant = /* GraphQL */ `mutation CreatePlant(
  $condition: ModelPlantConditionInput
  $input: CreatePlantInput!
) {
  createPlant(condition: $condition, input: $input) {
    bloom_details
    common_names
    createdAt
    foliage
    growth_rate
    hardiness_zones
    height
    images
    lifecycle
    maintenance_level
    plant_id
    plant_type
    propagation_methods
    resistances
    scientific_name
    soil_ph_preferences
    special_features
    spread
    sunlight_requirements
    timestamps
    toxicity
    updatedAt
    water_preferences
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePlantMutationVariables,
  APITypes.CreatePlantMutation
>;
export const createProject = /* GraphQL */ `mutation CreateProject(
  $condition: ModelProjectConditionInput
  $input: CreateProjectInput!
) {
  createProject(condition: $condition, input: $input) {
    company_id
    createdAt
    created_by
    customer_id
    description
    end_date
    modified_by
    project_id
    project_name
    property_details
    proposal_status
    start_date
    status
    timestamps
    total_estimated_cost
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProjectMutationVariables,
  APITypes.CreateProjectMutation
>;
export const createProjectComment = /* GraphQL */ `mutation CreateProjectComment(
  $condition: ModelProjectCommentConditionInput
  $input: CreateProjectCommentInput!
) {
  createProjectComment(condition: $condition, input: $input) {
    attachments
    comment_text
    coordinates
    createdAt
    pk
    sk
    timestamps
    updatedAt
    user_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProjectCommentMutationVariables,
  APITypes.CreateProjectCommentMutation
>;
export const createProjectItem = /* GraphQL */ `mutation CreateProjectItem(
  $condition: ModelProjectItemConditionInput
  $input: CreateProjectItemInput!
) {
  createProjectItem(condition: $condition, input: $input) {
    company_id
    createdAt
    inventory_id
    placement_coordinates
    placement_properties
    quantity
    status
    timestamps
    type
    unit_price
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProjectItemMutationVariables,
  APITypes.CreateProjectItemMutation
>;
export const createProjectItemComment = /* GraphQL */ `mutation CreateProjectItemComment(
  $condition: ModelProjectItemCommentConditionInput
  $input: CreateProjectItemCommentInput!
) {
  createProjectItemComment(condition: $condition, input: $input) {
    attachments
    comment_text
    coordinates
    createdAt
    pk
    sk
    timestamps
    updatedAt
    user_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProjectItemCommentMutationVariables,
  APITypes.CreateProjectItemCommentMutation
>;
export const createTask = /* GraphQL */ `mutation CreateTask(
  $condition: ModelTaskConditionInput
  $input: CreateTaskInput!
) {
  createTask(condition: $condition, input: $input) {
    assigned_to
    category
    createdAt
    description
    estimated_hours
    frequency
    pk
    priority
    project_item_id
    recurring_pattern
    scheduled_date
    sk
    status
    task_name
    timestamps
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTaskMutationVariables,
  APITypes.CreateTaskMutation
>;
export const createTaskComment = /* GraphQL */ `mutation CreateTaskComment(
  $condition: ModelTaskCommentConditionInput
  $input: CreateTaskCommentInput!
) {
  createTaskComment(condition: $condition, input: $input) {
    attachments
    comment_text
    createdAt
    pk
    sk
    timestamps
    updatedAt
    user_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTaskCommentMutationVariables,
  APITypes.CreateTaskCommentMutation
>;
export const customAddBoundaryPoint = /* GraphQL */ `mutation CustomAddBoundaryPoint($input: AWSJSON, $projectId: String) {
  customAddBoundaryPoint(input: $input, projectId: $projectId)
}
` as GeneratedMutation<
  APITypes.CustomAddBoundaryPointMutationVariables,
  APITypes.CustomAddBoundaryPointMutation
>;
export const customAddCompany = /* GraphQL */ `mutation CustomAddCompany($input: AWSJSON) {
  customAddCompany(input: $input)
}
` as GeneratedMutation<
  APITypes.CustomAddCompanyMutationVariables,
  APITypes.CustomAddCompanyMutation
>;
export const customAddInventoryItem = /* GraphQL */ `mutation CustomAddInventoryItem($input: AWSJSON) {
  customAddInventoryItem(input: $input)
}
` as GeneratedMutation<
  APITypes.CustomAddInventoryItemMutationVariables,
  APITypes.CustomAddInventoryItemMutation
>;
export const customAddObject = /* GraphQL */ `mutation CustomAddObject($input: AWSJSON) {
  customAddObject(input: $input)
}
` as GeneratedMutation<
  APITypes.CustomAddObjectMutationVariables,
  APITypes.CustomAddObjectMutation
>;
export const customAddPlant = /* GraphQL */ `mutation CustomAddPlant($input: AWSJSON) {
  customAddPlant(input: $input)
}
` as GeneratedMutation<
  APITypes.CustomAddPlantMutationVariables,
  APITypes.CustomAddPlantMutation
>;
export const customAddProject = /* GraphQL */ `mutation CustomAddProject($input: AWSJSON) {
  customAddProject(input: $input)
}
` as GeneratedMutation<
  APITypes.CustomAddProjectMutationVariables,
  APITypes.CustomAddProjectMutation
>;
export const customDeductInventoryQuantities = /* GraphQL */ `mutation CustomDeductInventoryQuantities($companyId: String, $input: AWSJSON) {
  customDeductInventoryQuantities(companyId: $companyId, input: $input)
}
` as GeneratedMutation<
  APITypes.CustomDeductInventoryQuantitiesMutationVariables,
  APITypes.CustomDeductInventoryQuantitiesMutation
>;
export const customDeleteBoundaryPoint = /* GraphQL */ `mutation CustomDeleteBoundaryPoint($point_id: String, $projectId: String) {
  customDeleteBoundaryPoint(point_id: $point_id, projectId: $projectId)
}
` as GeneratedMutation<
  APITypes.CustomDeleteBoundaryPointMutationVariables,
  APITypes.CustomDeleteBoundaryPointMutation
>;
export const customDeleteCompany = /* GraphQL */ `mutation CustomDeleteCompany($companyId: String) {
  customDeleteCompany(companyId: $companyId)
}
` as GeneratedMutation<
  APITypes.CustomDeleteCompanyMutationVariables,
  APITypes.CustomDeleteCompanyMutation
>;
export const customDeleteInventoryItem = /* GraphQL */ `mutation CustomDeleteInventoryItem($inventoryId: String) {
  customDeleteInventoryItem(inventoryId: $inventoryId)
}
` as GeneratedMutation<
  APITypes.CustomDeleteInventoryItemMutationVariables,
  APITypes.CustomDeleteInventoryItemMutation
>;
export const customDeleteObject = /* GraphQL */ `mutation CustomDeleteObject($objectId: String) {
  customDeleteObject(objectId: $objectId)
}
` as GeneratedMutation<
  APITypes.CustomDeleteObjectMutationVariables,
  APITypes.CustomDeleteObjectMutation
>;
export const customDeletePlant = /* GraphQL */ `mutation CustomDeletePlant($plantId: String) {
  customDeletePlant(plantId: $plantId)
}
` as GeneratedMutation<
  APITypes.CustomDeletePlantMutationVariables,
  APITypes.CustomDeletePlantMutation
>;
export const customDeleteProject = /* GraphQL */ `mutation CustomDeleteProject($projectId: String) {
  customDeleteProject(projectId: $projectId)
}
` as GeneratedMutation<
  APITypes.CustomDeleteProjectMutationVariables,
  APITypes.CustomDeleteProjectMutation
>;
export const customUpdateBoundaryPoint = /* GraphQL */ `mutation CustomUpdateBoundaryPoint(
  $input: AWSJSON
  $point_id: String
  $projectId: String
) {
  customUpdateBoundaryPoint(
    input: $input
    point_id: $point_id
    projectId: $projectId
  )
}
` as GeneratedMutation<
  APITypes.CustomUpdateBoundaryPointMutationVariables,
  APITypes.CustomUpdateBoundaryPointMutation
>;
export const customUpdateCompany = /* GraphQL */ `mutation CustomUpdateCompany($companyId: String, $input: AWSJSON) {
  customUpdateCompany(companyId: $companyId, input: $input)
}
` as GeneratedMutation<
  APITypes.CustomUpdateCompanyMutationVariables,
  APITypes.CustomUpdateCompanyMutation
>;
export const customUpdateInventoryItem = /* GraphQL */ `mutation CustomUpdateInventoryItem($input: AWSJSON, $inventoryId: String) {
  customUpdateInventoryItem(input: $input, inventoryId: $inventoryId)
}
` as GeneratedMutation<
  APITypes.CustomUpdateInventoryItemMutationVariables,
  APITypes.CustomUpdateInventoryItemMutation
>;
export const customUpdateObject = /* GraphQL */ `mutation CustomUpdateObject($input: AWSJSON, $objectId: String) {
  customUpdateObject(input: $input, objectId: $objectId)
}
` as GeneratedMutation<
  APITypes.CustomUpdateObjectMutationVariables,
  APITypes.CustomUpdateObjectMutation
>;
export const customUpdatePlant = /* GraphQL */ `mutation CustomUpdatePlant($input: AWSJSON, $plantId: String) {
  customUpdatePlant(input: $input, plantId: $plantId)
}
` as GeneratedMutation<
  APITypes.CustomUpdatePlantMutationVariables,
  APITypes.CustomUpdatePlantMutation
>;
export const customUpdateProject = /* GraphQL */ `mutation CustomUpdateProject($input: AWSJSON, $projectId: String) {
  customUpdateProject(input: $input, projectId: $projectId)
}
` as GeneratedMutation<
  APITypes.CustomUpdateProjectMutationVariables,
  APITypes.CustomUpdateProjectMutation
>;
export const customUpdateProjectBoundary = /* GraphQL */ `mutation CustomUpdateProjectBoundary($input: AWSJSON, $projectId: String) {
  customUpdateProjectBoundary(input: $input, projectId: $projectId)
}
` as GeneratedMutation<
  APITypes.CustomUpdateProjectBoundaryMutationVariables,
  APITypes.CustomUpdateProjectBoundaryMutation
>;
export const deleteCompany = /* GraphQL */ `mutation DeleteCompany(
  $condition: ModelCompanyConditionInput
  $input: DeleteCompanyInput!
) {
  deleteCompany(condition: $condition, input: $input) {
    address
    business_hours
    company_id
    contact_email
    contact_phone
    createdAt
    description
    logo
    name
    service_areas
    timestamps
    updatedAt
    website
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCompanyMutationVariables,
  APITypes.DeleteCompanyMutation
>;
export const deleteCustomer = /* GraphQL */ `mutation DeleteCustomer(
  $condition: ModelCustomerConditionInput
  $input: DeleteCustomerInput!
) {
  deleteCustomer(condition: $condition, input: $input) {
    address
    billing_info
    createdAt
    notes
    pk
    preferences
    sk
    timestamps
    updatedAt
    user_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCustomerMutationVariables,
  APITypes.DeleteCustomerMutation
>;
export const deleteItemInventory = /* GraphQL */ `mutation DeleteItemInventory(
  $condition: ModelItemInventoryConditionInput
  $input: DeleteItemInventoryInput!
) {
  deleteItemInventory(condition: $condition, input: $input) {
    company_id
    createdAt
    customer_price
    inventory_id
    item_id
    last_restocked
    location_in_warehouse
    quantity
    restock_threshold
    status
    supplier
    timestamps
    type
    unit_cost
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteItemInventoryMutationVariables,
  APITypes.DeleteItemInventoryMutation
>;
export const deleteLandscapeObject = /* GraphQL */ `mutation DeleteLandscapeObject(
  $condition: ModelLandscapeObjectConditionInput
  $input: DeleteLandscapeObjectInput!
) {
  deleteLandscapeObject(condition: $condition, input: $input) {
    category
    color
    createdAt
    dimensions
    images
    installation_difficulty
    maintenance_level
    manufacturer
    material
    name
    object_id
    price_range
    timestamps
    updatedAt
    weather_resistance
    weight
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLandscapeObjectMutationVariables,
  APITypes.DeleteLandscapeObjectMutation
>;
export const deletePlant = /* GraphQL */ `mutation DeletePlant(
  $condition: ModelPlantConditionInput
  $input: DeletePlantInput!
) {
  deletePlant(condition: $condition, input: $input) {
    bloom_details
    common_names
    createdAt
    foliage
    growth_rate
    hardiness_zones
    height
    images
    lifecycle
    maintenance_level
    plant_id
    plant_type
    propagation_methods
    resistances
    scientific_name
    soil_ph_preferences
    special_features
    spread
    sunlight_requirements
    timestamps
    toxicity
    updatedAt
    water_preferences
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePlantMutationVariables,
  APITypes.DeletePlantMutation
>;
export const deleteProject = /* GraphQL */ `mutation DeleteProject(
  $condition: ModelProjectConditionInput
  $input: DeleteProjectInput!
) {
  deleteProject(condition: $condition, input: $input) {
    company_id
    createdAt
    created_by
    customer_id
    description
    end_date
    modified_by
    project_id
    project_name
    property_details
    proposal_status
    start_date
    status
    timestamps
    total_estimated_cost
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProjectMutationVariables,
  APITypes.DeleteProjectMutation
>;
export const deleteProjectComment = /* GraphQL */ `mutation DeleteProjectComment(
  $condition: ModelProjectCommentConditionInput
  $input: DeleteProjectCommentInput!
) {
  deleteProjectComment(condition: $condition, input: $input) {
    attachments
    comment_text
    coordinates
    createdAt
    pk
    sk
    timestamps
    updatedAt
    user_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProjectCommentMutationVariables,
  APITypes.DeleteProjectCommentMutation
>;
export const deleteProjectItem = /* GraphQL */ `mutation DeleteProjectItem(
  $condition: ModelProjectItemConditionInput
  $input: DeleteProjectItemInput!
) {
  deleteProjectItem(condition: $condition, input: $input) {
    company_id
    createdAt
    inventory_id
    placement_coordinates
    placement_properties
    quantity
    status
    timestamps
    type
    unit_price
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProjectItemMutationVariables,
  APITypes.DeleteProjectItemMutation
>;
export const deleteProjectItemComment = /* GraphQL */ `mutation DeleteProjectItemComment(
  $condition: ModelProjectItemCommentConditionInput
  $input: DeleteProjectItemCommentInput!
) {
  deleteProjectItemComment(condition: $condition, input: $input) {
    attachments
    comment_text
    coordinates
    createdAt
    pk
    sk
    timestamps
    updatedAt
    user_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProjectItemCommentMutationVariables,
  APITypes.DeleteProjectItemCommentMutation
>;
export const deleteTask = /* GraphQL */ `mutation DeleteTask(
  $condition: ModelTaskConditionInput
  $input: DeleteTaskInput!
) {
  deleteTask(condition: $condition, input: $input) {
    assigned_to
    category
    createdAt
    description
    estimated_hours
    frequency
    pk
    priority
    project_item_id
    recurring_pattern
    scheduled_date
    sk
    status
    task_name
    timestamps
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTaskMutationVariables,
  APITypes.DeleteTaskMutation
>;
export const deleteTaskComment = /* GraphQL */ `mutation DeleteTaskComment(
  $condition: ModelTaskCommentConditionInput
  $input: DeleteTaskCommentInput!
) {
  deleteTaskComment(condition: $condition, input: $input) {
    attachments
    comment_text
    createdAt
    pk
    sk
    timestamps
    updatedAt
    user_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTaskCommentMutationVariables,
  APITypes.DeleteTaskCommentMutation
>;
export const updateCompany = /* GraphQL */ `mutation UpdateCompany(
  $condition: ModelCompanyConditionInput
  $input: UpdateCompanyInput!
) {
  updateCompany(condition: $condition, input: $input) {
    address
    business_hours
    company_id
    contact_email
    contact_phone
    createdAt
    description
    logo
    name
    service_areas
    timestamps
    updatedAt
    website
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCompanyMutationVariables,
  APITypes.UpdateCompanyMutation
>;
export const updateCustomer = /* GraphQL */ `mutation UpdateCustomer(
  $condition: ModelCustomerConditionInput
  $input: UpdateCustomerInput!
) {
  updateCustomer(condition: $condition, input: $input) {
    address
    billing_info
    createdAt
    notes
    pk
    preferences
    sk
    timestamps
    updatedAt
    user_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCustomerMutationVariables,
  APITypes.UpdateCustomerMutation
>;
export const updateItemInventory = /* GraphQL */ `mutation UpdateItemInventory(
  $condition: ModelItemInventoryConditionInput
  $input: UpdateItemInventoryInput!
) {
  updateItemInventory(condition: $condition, input: $input) {
    company_id
    createdAt
    customer_price
    inventory_id
    item_id
    last_restocked
    location_in_warehouse
    quantity
    restock_threshold
    status
    supplier
    timestamps
    type
    unit_cost
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateItemInventoryMutationVariables,
  APITypes.UpdateItemInventoryMutation
>;
export const updateLandscapeObject = /* GraphQL */ `mutation UpdateLandscapeObject(
  $condition: ModelLandscapeObjectConditionInput
  $input: UpdateLandscapeObjectInput!
) {
  updateLandscapeObject(condition: $condition, input: $input) {
    category
    color
    createdAt
    dimensions
    images
    installation_difficulty
    maintenance_level
    manufacturer
    material
    name
    object_id
    price_range
    timestamps
    updatedAt
    weather_resistance
    weight
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLandscapeObjectMutationVariables,
  APITypes.UpdateLandscapeObjectMutation
>;
export const updatePlant = /* GraphQL */ `mutation UpdatePlant(
  $condition: ModelPlantConditionInput
  $input: UpdatePlantInput!
) {
  updatePlant(condition: $condition, input: $input) {
    bloom_details
    common_names
    createdAt
    foliage
    growth_rate
    hardiness_zones
    height
    images
    lifecycle
    maintenance_level
    plant_id
    plant_type
    propagation_methods
    resistances
    scientific_name
    soil_ph_preferences
    special_features
    spread
    sunlight_requirements
    timestamps
    toxicity
    updatedAt
    water_preferences
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePlantMutationVariables,
  APITypes.UpdatePlantMutation
>;
export const updateProject = /* GraphQL */ `mutation UpdateProject(
  $condition: ModelProjectConditionInput
  $input: UpdateProjectInput!
) {
  updateProject(condition: $condition, input: $input) {
    company_id
    createdAt
    created_by
    customer_id
    description
    end_date
    modified_by
    project_id
    project_name
    property_details
    proposal_status
    start_date
    status
    timestamps
    total_estimated_cost
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProjectMutationVariables,
  APITypes.UpdateProjectMutation
>;
export const updateProjectComment = /* GraphQL */ `mutation UpdateProjectComment(
  $condition: ModelProjectCommentConditionInput
  $input: UpdateProjectCommentInput!
) {
  updateProjectComment(condition: $condition, input: $input) {
    attachments
    comment_text
    coordinates
    createdAt
    pk
    sk
    timestamps
    updatedAt
    user_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProjectCommentMutationVariables,
  APITypes.UpdateProjectCommentMutation
>;
export const updateProjectItem = /* GraphQL */ `mutation UpdateProjectItem(
  $condition: ModelProjectItemConditionInput
  $input: UpdateProjectItemInput!
) {
  updateProjectItem(condition: $condition, input: $input) {
    company_id
    createdAt
    inventory_id
    placement_coordinates
    placement_properties
    quantity
    status
    timestamps
    type
    unit_price
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProjectItemMutationVariables,
  APITypes.UpdateProjectItemMutation
>;
export const updateProjectItemComment = /* GraphQL */ `mutation UpdateProjectItemComment(
  $condition: ModelProjectItemCommentConditionInput
  $input: UpdateProjectItemCommentInput!
) {
  updateProjectItemComment(condition: $condition, input: $input) {
    attachments
    comment_text
    coordinates
    createdAt
    pk
    sk
    timestamps
    updatedAt
    user_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProjectItemCommentMutationVariables,
  APITypes.UpdateProjectItemCommentMutation
>;
export const updateTask = /* GraphQL */ `mutation UpdateTask(
  $condition: ModelTaskConditionInput
  $input: UpdateTaskInput!
) {
  updateTask(condition: $condition, input: $input) {
    assigned_to
    category
    createdAt
    description
    estimated_hours
    frequency
    pk
    priority
    project_item_id
    recurring_pattern
    scheduled_date
    sk
    status
    task_name
    timestamps
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTaskMutationVariables,
  APITypes.UpdateTaskMutation
>;
export const updateTaskComment = /* GraphQL */ `mutation UpdateTaskComment(
  $condition: ModelTaskCommentConditionInput
  $input: UpdateTaskCommentInput!
) {
  updateTaskComment(condition: $condition, input: $input) {
    attachments
    comment_text
    createdAt
    pk
    sk
    timestamps
    updatedAt
    user_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTaskCommentMutationVariables,
  APITypes.UpdateTaskCommentMutation
>;
